<template>
  <section class="gt-page">
    <div class="gt-page-inner compact">
      <header class="hero gt-card">
        <div>
          <span class="gt-pill">Mi portal RH</span>
          <h1>{{ profile.employee?.display_name || 'Mis horas' }}</h1>
          <p class="gt-muted">Consulta tus checadas y el total de la semana.</p>
        </div>
        <router-link v-if="$store.getters.hasPermission('comandero.access')" class="gt-button primary link-button" to="/comandero">Abrir comandero</router-link>
      </header>

      <p v-if="error" class="error-box">{{ error }}</p>
      <div v-if="loading" class="gt-card loading">Cargando tus horas…</div>
      <template v-else-if="profile.employee">
        <div class="summary-grid">
          <article class="gt-card"><small>Semana</small><strong>{{ number(profile.summary?.worked_hours) }} h</strong><span>{{ profile.week?.start }} — {{ profile.week?.end }}</span></article>
          <article class="gt-card"><small>Tiempo extra</small><strong>{{ number(profile.summary?.overtime_hours) }} h</strong><span>Sobre tu jornada configurada</span></article>
          <article class="gt-card"><small>Estado</small><strong>{{ profile.summary?.is_clocked_in ? 'En turno' : 'Fuera' }}</strong><span>{{ profile.employee.job_title || profile.employee.employee_code }}</span></article>
        </div>
        <section class="gt-card entries-card">
          <header><div><h2>Mis checadas</h2><p class="gt-muted">Horario de Ciudad de México</p></div><div><input v-model="weekStart" type="date" /><button class="gt-button soft" @click="load">Consultar</button></div></header>
          <article v-for="entry in profile.entries || []" :key="entry.id">
            <div><strong>{{ date(entry.clock_in_at) }}</strong><span>{{ time(entry.clock_in_at) }} → {{ entry.clock_out_at ? time(entry.clock_out_at) : 'En turno' }}</span></div>
            <strong>{{ number(entry.worked_hours) }} h</strong>
          </article>
          <p v-if="!(profile.entries || []).length" class="empty">No hay checadas en esta semana.</p>
        </section>
      </template>
    </div>
  </section>
</template>

<script>
import api from '@/services/api';

function mondayKey() {
  const now = new Date();
  const day = now.getDay() || 7;
  now.setDate(now.getDate() - day + 1);
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
}

export default {
  name: 'HrSelfView',
  data() { return { loading: false, error: '', weekStart: mondayKey(), profile: {} }; },
  mounted() { this.load(); },
  methods: {
    async load() {
      this.loading = true; this.error = '';
      try { const { data } = await api.get('/api/pos/hr/me', { params: { week_start: this.weekStart } }); this.profile = data; }
      catch (error) { this.error = error.response?.data?.error || 'No se pudieron cargar tus horas.'; }
      finally { this.loading = false; }
    },
    number(value) { return Number(value || 0).toFixed(2); },
    parsed(value) { return new Date(value); },
    date(value) { return new Intl.DateTimeFormat('es-MX', { dateStyle: 'medium', timeZone: 'America/Mexico_City' }).format(this.parsed(value)); },
    time(value) { return new Intl.DateTimeFormat('es-MX', { timeStyle: 'short', timeZone: 'America/Mexico_City' }).format(this.parsed(value)); },
  },
};
</script>

<style lang="scss" scoped>
.compact { max-width: 980px; }.hero { display: flex; justify-content: space-between; gap: 1rem; align-items: center; padding: 1.6rem; }.hero h1 { margin: .65rem 0 .25rem; }.hero p { margin: 0; }.link-button { text-decoration: none; }.summary-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1rem; margin: 1rem 0; }.summary-grid article { padding: 1.15rem; }.summary-grid small, .summary-grid span { display: block; color: var(--gt-muted); }.summary-grid strong { display: block; margin: .45rem 0; font-size: 1.75rem; }.entries-card { padding: 1.2rem; }.entries-card > header { display: flex; justify-content: space-between; align-items: center; gap: 1rem; margin-bottom: .8rem; }.entries-card h2, .entries-card p { margin: 0; }.entries-card header > div:last-child { display: flex; gap: .5rem; }.entries-card input { border: 1px solid var(--gt-border); border-radius: 14px; padding: .7rem; }.entries-card > article { display: flex; justify-content: space-between; gap: 1rem; padding: .85rem; border-top: 1px solid var(--gt-border); }.entries-card article span { display: block; margin-top: .2rem; color: var(--gt-muted); }.error-box, .loading { margin-top: 1rem; padding: 1rem; border-radius: 18px; }.error-box { color: var(--gt-danger); background: #fff0ec; }.empty { padding: 1.5rem; text-align: center; color: var(--gt-muted); }@media (max-width: 720px) { .hero { align-items: flex-start; flex-direction: column; }.summary-grid { grid-template-columns: 1fr; }.entries-card > header { align-items: flex-start; flex-direction: column; }.entries-card header > div:last-child { width: 100%; flex-wrap: wrap; } }
</style>
